<script>
import ListViewTemplate from './ListViewTemplate'

import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import feedbackMixin from '../mixins/feedback'
import listViewMixin from '../mixins/list-view'
import exportFileMixin from "../mixins/export-file";

Vue.use(VueAxios, axios);

export default {
	name: 'Registrations',
	mixins: [feedbackMixin, listViewMixin, exportFileMixin],
	extends: ListViewTemplate,
	data() {
		return {
			primaryKey: 'Record_Number_PK_ID',
			columns: [
				{
					name: 'Registration Number',
					displayName: 'Number',
					sort: 0
				},
				{
					name: 'Company ID',
					displayName: 'Comp ID',
					searchName: 'Company ID',
					pk: true,
					sort: 0
				},
				{
					name: 'Company Name',
					displayName: 'Company Name',
					sort: 0
				},
				{
					name: 'Activity',
					displayName: 'Activity',
					sort: 0
				},
				{
					name: 'Expiration Date',
					displayName: 'Expiration',
					expired: true,
					sort: 0
				},
				{
					name: 'Status Mask',
					displayName: 'Status',
					status: true,
					sort: 0
				},
				{
					name: 'Federal/State License',
					displayName: 'Federal/State',
					sort: 0
				},
				{
					name: 'Agency',
					displayName: 'Agency',
					sort: 0
				},
				/*{
                    name: 'Federal Agency',
                    displayName: 'Federal Agency',
                    sort: 0
                },
                {
                    name: 'State Agency',
                    displayName: 'State Agency',
                    sort: 0
                },*/
				{
					name: 'Address 1',
					displayName: 'Address',
					sort: 0
				},
				{
					name: 'City',
					displayName: 'City',
					sort: 0
				},
				{
					name: 'Date Created',
					displayName: 'Created',
					sort: 0
				},
				{
					name: 'Date Modified',
					displayName: 'Modified',
					sort: 0
				}
			],
			fields: [
				{
					key: 'Registration Number',
					label: 'Number',
					sortable: true,
					stickyColumn: true
				},
				{
					key: 'Company ID',
					label: 'Company ID',
					searchName: 'Company ID',
					pk: true,
					sortable: true
				},
				{
					key: 'Company Name',
					label: 'Company Name',
					sortable: true
				},
				{
					key: 'Activity',
					label: 'Activity',
					sortable: true
				},
				{
					key: 'Expiration Date',
					label: 'Expiration',
					expired: true,
					sortable: true
				},
				{
					key: 'Status Mask',
					label: 'Status',
					status: true,
					sortable: true
				},
				{
					key: 'Federal/State License',
					label: 'Federal/State',
					sortable: true
				},
				{
					key: 'Agency',
					label: 'Agency',
					sortable: true
				},
				/*{
                    key: 'Federal Agency',
                    label: 'Federal Agency',
                    sortable: true
                },
                {
                    key: 'State Agency',
                    label: 'State Agency',
                    sortable: true
                },*/
				{
					key: 'Address 1',
					label: 'Address',
					sortable: true
				},
				{
					key: 'City',
					label: 'City',
					sortable: true
				},
				{
					key: 'Date Created',
					date: true,
					label: 'Created',
					sortable: true
				},
				{
					key: 'Date Modified',
					date: true,
					label: 'Modified',
					sortable: true
				}
			],
			headerTitle: 'Registrations',
			restEntity: 'registrations',
			restDetailEntity: 'registration',
			leftmostColumn: 'cell(Registration Number)'
		}
	}
}
</script>
<style>
.b-table tr th, .b-table tr td {
    white-space: nowrap !important;
}

.b-table tr th, .b-table tr td {
    font-size: 12px !important;
}

ul.pagination {
    margin-bottom: 0 !important;
}
</style>